export default {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    cardContainer: {
        marginBottom: "20px",
        width: "100%",
        height: "auto",
    },
    cardCustomStyles: {
        backgroundColor: "#EAEEE9",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        maxWidth: "1000px",
    },
    cardHeading: {
        marginTop: "20px",
        width: "57%",
        textAlign: "center",
        marginBottom: '20px',
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#333'
    },
    fieldContainer: {
        width: "60%",
        marginBottom: "5px",
    },
    buttonContainer: {
        textAlign: "center",
        margin: "10px 0px 0px 400px"
    },
    gridRecordsMargin: {
        marginLeft: '150px',
    },
    dropdownWidth: {
        width: '120px',
    },
}